'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import UPElement1 from '@/components/UPElement1';
import FAQSection from '@/components/FAQSection';
import { universalPanelFaqs } from '@/data/faqData';

const UniversalPanelPage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Panel Filters' }]} />
        <div className="container-0">
          <UPElement1 />
          <FAQSection faqs={universalPanelFaqs} title="FAQs About Panel Air Filters" />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default UniversalPanelPage;
